import { Box, Typography } from '@mui/material'
import { DVD } from './DVD'
import { useComponentSizeAndPosition } from '../shared/utils'
import { NavBar } from './Navigation'
import { LoadingPicture } from '../shared/LoadingPicture'

function BodyText() {
  return (
    <Box sx={{ fontWeight: '400' }}>
      <Typography sx={{ marginBottom: '20px' }}>
        6 years ago, we got married at the happiest place in New York - City
        Hall. Tam wore a lilac silk slip with raw edge side seams, and Jason
        wore a navy suit and a bow tie. Tam’s bouquet was from the lovely
        Sunny’s in East Village.
      </Typography>
      <Typography sx={{ marginBottom: '20px' }}>
        The event was short and sweet, and was followed by a dinner at our
        beloved Lower East Side institution, Congee Village. We ended the night
        with karaoke - there were no pictures from the night, only the silliest
        memories seared into our friend’s minds (Jason and I did not remember
        much from that night).
      </Typography>
      <Typography sx={{ marginBottom: '20px' }}>
        6 years later, we want to celebrate our milestone of 10 years of being
        together.
      </Typography>
    </Box>
  )
}

function HomeDesktop() {
  const { boxRef, width, height } = useComponentSizeAndPosition()

  return (
    <Box
      ref={boxRef}
      sx={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
      }}
    >
      {width && height && (
        <DVD
          containerHeight={height}
          containerWidth={width}
          initialX={width - 100}
          initialY={height - 200}
          radius={100}
          text="Big yellow button"
        />
      )}

      <Box
        sx={{
          flexShrink: 0,
          width: '350px',
          height: '100%',
          backgroundColor: 'white',
          display: 'flex',
          flexDirection: 'column',
          padding: '0 20px 0 50px',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="h2"
          fontSize="3rem"
          sx={{ fontWeight: '800', lineHeight: '1.15' }}
        >
          JASON AND TAMMY RENEW THEIR VOWS IN THE CATSKILLS ON SEP 2025
        </Typography>
      </Box>
      <Box
        sx={{
          width: '100%', // Take up the rest of the space
          height: '100%',
          //   overflow: 'hidden',
          margin: '0 auto',
          position: 'relative',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-70%, -40%)',
            zIndex: 1,
            backgroundColor: 'white',
            border: '1.5px solid black',
            // borderWidth: '3px',
            padding: '25px',
            width: '440px',
            rotate: '12deg',
          }}
        >
          <BodyText />

          <LoadingPicture
            imageId="wedding_home_detail.png"
            stage="prod"
            style={{
              padding: '0 30px 10px 30px',
              width: '100%',
              height: 'auto',
              objectFit: 'cover',
              clipPath: 'inset(0 10% 0 10%)',
            }}
            size="medium"
          />

          <NavBar direction="column" />
        </Box>
        <img
          src="https://jasonandfriends-prod-pictures-bucket.s3.us-east-1.amazonaws.com/processed/wedding_home.jpg/medium_wedding_home.jpg"
          alt="Jason and Tammy"
          style={{
            width: '100%',
            height: '170%', // 150% to crop the bottom half
            objectFit: 'cover',
            objectPosition: '0% 0%',
          }}
        />
      </Box>
    </Box>
  )
}

function HomeMobile() {
  const { boxRef, width, height } = useComponentSizeAndPosition()

  return (
    <Box
      ref={boxRef}
      sx={{
        width: '100vw',
        height: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      {width && height && (
        <DVD
          containerHeight={height}
          containerWidth={width}
          initialX={width - 75}
          initialY={height - 150}
          radius={100}
          text="Big yellow button"
        />
      )}
      <Typography
        variant="h2"
        fontSize="27px"
        sx={{ padding: '10px 10px 10px 10px', flexShrink: 0 }}
        fontWeight="800"
      >
        JASON AND TAMMY RENEW THEIR VOWS IN CATSKILL ON SEP 2025
      </Typography>
      <Box
        sx={{
          backgroundImage:
            'url(https://jasonandfriends-prod-pictures-bucket.s3.us-east-1.amazonaws.com/processed/wedding_home.jpg/medium_wedding_home.jpg)',
          backgroundSize: '100% 130%',
          height: '100%',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            zIndex: 1,
            background: 'white',
            border: '1px solid black',
            padding: '20px',
            width: '300px',
            height: '500px',
            marginTop: '35px',
            rotate: '6deg',
          }}
        >
          <Box>
            <Typography sx={{ marginBottom: '15px', fontSize: '14px' }}>
              6 years ago, we got married at the happiest place in New York -
              City Hall. Tam wore a lilac silk slip with raw edge side seams,
              and Jason wore a navy suit and a bow tie. Tam’s bouquet was from
              the lovely Sunny’s in East Village.
            </Typography>
            <Typography sx={{ marginBottom: '15px', fontSize: '14px' }}>
              The event was short and sweet, and was followed by a dinner at our
              beloved Lower East Side institution, Congee Village. We ended the
              night with karaoke - there were no pictures from the night, only
              the silliest memories seared into our friend’s minds (Jason and I
              did not remember much from that night).
            </Typography>

            <Typography
              sx={{
                marginBottom: '15px',
                fontSize: '14px',
                lineHeight: '16px',
              }}
            >
              6 years later, we want to celebrate our milestone of 10 years of
              being together.
            </Typography>
          </Box>

          <NavBar direction="column" />
        </Box>
      </Box>
    </Box>
  )
}

export function Home() {
  const isMobile = window.innerWidth < 768
  return isMobile ? <HomeMobile /> : <HomeDesktop />
}
